import { FC, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SocialBox from './SocialBox';
import { CampaignMode, Media } from '../../interfaces/campaign';
import { CampaignContext } from '../../contexts/CampaignContext';
import { isCampaignCreateMode } from '../../utils/string';

type ICampaignSocials = {
	mode: CampaignMode;
};

const CampaignSocials: FC<ICampaignSocials> = ({ mode }) => {
	const { selectedPlatform, fetchedCampaign, fetchedMedias, setSelectedPlatform, setSelectedPlatformId } = useContext(CampaignContext);

	const isCreateMode = isCampaignCreateMode(mode);

	const { t } = useTranslation();

	const handleCheckboxChange = (platform: Media, platformId: number, checked: boolean) => {
		setSelectedPlatform && setSelectedPlatform(checked ? platform : null);
		setSelectedPlatformId && setSelectedPlatformId(checked ? platformId : null);
	};

	return (
		<Box className="mt-4 rounded-lg bg-background-paper px-6 pb-8 pt-6">
			<Box>
				<Typography className="mb-4 text-xl text-text-primary">{t('social_networks')}</Typography>
				<Box className="flex flex-wrap justify-center gap-4">
					{fetchedMedias
						?.filter(item => item.is_social && item?.system_name !== 'soroush')
						?.map((media, i) => {
							const isSelected = fetchedCampaign?.media === media.system_name;
							const isDimmed = !!selectedPlatform && !isSelected;

							return <SocialBox key={i} platform={media?.system_name as Media} selected={!isCreateMode ? isSelected : selectedPlatform === media.system_name} dimmed={isDimmed} mode={mode} platformId={media?.id} onChange={handleCheckboxChange} />;
						})}
				</Box>

				<Typography className="mb-4 mt-6 text-xl text-text-primary">{t('rest-of-services')}</Typography>
				<Box className="flex flex-wrap justify-center gap-4">
					{fetchedMedias
						?.filter(item => !item.is_social)
						?.map((media, i) => {
							const isSelected = fetchedCampaign?.media === media.system_name;
							const isDimmed = !!selectedPlatform && !isSelected;

							return <SocialBox key={i} platform={media?.system_name as Media} selected={!isCreateMode ? isSelected : selectedPlatform === media.system_name} dimmed={isDimmed} mode={mode} platformId={media?.id} onChange={handleCheckboxChange} />;
						})}
				</Box>
			</Box>
		</Box>
	);
};

export default CampaignSocials;
